import { APP_CONFIG } from '@/lib/config/constants'
import type { OnboardingState } from './types'

const STORAGE_KEY = APP_CONFIG.STORAGE_KEYS.ONBOARDING_STATE

/**
 * Load onboarding state from localStorage
 */
export function loadState(): OnboardingState {
  if (typeof window === 'undefined') return { completedTaskIds: [] }

  const raw = window.localStorage.getItem(STORAGE_KEY)
  if (!raw) return { completedTaskIds: [] }

  try {
    const parsed = JSON.parse(raw) as OnboardingState
    return {
      completedTaskIds: parsed.completedTaskIds ?? [],
      seededAt: parsed.seededAt,
      lifecycle: parsed.lifecycle ?? {},
    }
  } catch {
    return { completedTaskIds: [] }
  }
}

/**
 * Save onboarding state to localStorage
 */
export function saveState(state: OnboardingState): void {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
}
